import { useState } from "react";
import ProgressBar from "../../Shared/ProgressBar";

const BingeEating = () => {
    const [selectedAnswers, setSelectedAnswers] = useState({
        q1: "",
        q2: "",
        q3: "",
        q4: "",
        q5: "",
        q6: "",
        q7: "",
        q8: "",
        q9: "",
        q10: "",
        q11: "",
        q12: "",
        q13: "",
        q14: "",
        q15: "",
        q16: "",
        q17: "",
        q18: "",
        q19: ""
    });
    const [score, setScore] = useState(null); // To store the final risk score

    const handleSelection = (question, answer) => {
        setSelectedAnswers((prevState) => ({
            ...prevState,
            [question]: answer,
        }));
    };


    const calculateScore = () => {
        let totalScore = 0;
        if (selectedAnswers.q1 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q1 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q1 === "very_true") totalScore += 3;
        if (selectedAnswers.q1 === "completely_true") totalScore += 4;

        if (selectedAnswers.q2 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q2 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q2 === "very_true") totalScore += 3;
        if (selectedAnswers.q2 === "completely_true") totalScore += 4;

        if (selectedAnswers.q3 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q3 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q3 === "very_true") totalScore += 3;
        if (selectedAnswers.q3 === "completely_true") totalScore += 4;


        if (selectedAnswers.q4 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q4 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q4 === "very_true") totalScore += 3;
        if (selectedAnswers.q4 === "completely_true") totalScore += 4;

        if (selectedAnswers.q5 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q5 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q5 === "very_true") totalScore += 3;
        if (selectedAnswers.q5 === "completely_true") totalScore += 4;

        if (selectedAnswers.q6 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q6 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q6 === "very_true") totalScore += 3;
        if (selectedAnswers.q6 === "completely_true") totalScore += 4;

        if (selectedAnswers.q7 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q7 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q7 === "very_true") totalScore += 3;
        if (selectedAnswers.q7 === "completely_true") totalScore += 4;

        if (selectedAnswers.q8 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q8 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q8 === "very_true") totalScore += 3;
        if (selectedAnswers.q8 === "completely_true") totalScore += 4;

        if (selectedAnswers.q9 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q9 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q9 === "very_true") totalScore += 3;
        if (selectedAnswers.q9 === "completely_true") totalScore += 4;

        if (selectedAnswers.q10 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q10 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q10 === "very_true") totalScore += 3;
        if (selectedAnswers.q10 === "completely_true") totalScore += 4;

        if (selectedAnswers.q11 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q11 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q11 === "very_true") totalScore += 3;
        if (selectedAnswers.q11 === "completely_true") totalScore += 4;

        if (selectedAnswers.q12 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q12 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q12 === "very_true") totalScore += 3;
        if (selectedAnswers.q12 === "completely_true") totalScore += 4;

        if (selectedAnswers.q13 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q13 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q13 === "very_true") totalScore += 3;
        if (selectedAnswers.q13 === "completely_true") totalScore += 4;

        if (selectedAnswers.q14 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q14 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q14 === "very_true") totalScore += 3;
        if (selectedAnswers.q14 === "completely_true") totalScore += 4;

        if (selectedAnswers.q15 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q15 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q15 === "very_true") totalScore += 3;
        if (selectedAnswers.q15 === "completely_true") totalScore += 4;

        if (selectedAnswers.q16 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q16 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q16 === "very_true") totalScore += 3;
        if (selectedAnswers.q16 === "completely_true") totalScore += 4;

        if (selectedAnswers.q17 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q17 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q17 === "very_true") totalScore += 3;
        if (selectedAnswers.q17 === "completely_true") totalScore += 4;

        if (selectedAnswers.q18 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q18 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q18 === "very_true") totalScore += 3;
        if (selectedAnswers.q18 === "completely_true") totalScore += 4;

        if (selectedAnswers.q19 === "slightly_true") totalScore += 1;
        if (selectedAnswers.q19 === "moderately_true") totalScore += 2;
        if (selectedAnswers.q19 === "very_true") totalScore += 3;
        if (selectedAnswers.q19 === "completely_true") totalScore += 4;


        setScore(totalScore);
    };

    return (
        <div>
            <div className="d-flex ">
                <div className="w-120">
                    <h1 className="font-lg mb-4">Binge Eating Assessment</h1>
                    <h3 className="font-md mb-4" style={{ fontWeight: 'bold' }}>Food Fantasies</h3>

                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">I often think about eating between meals.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q1 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q1", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>

                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">I often fantasize about eating things I really like.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q2 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q2", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Question 2 */}
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">I often crave certain kinds of food.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q3 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q3", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>

                    {/* Question 3 */}
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">I spend a lot of time thinking about food.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q4 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q4", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <h3 className="font-md mb-4" style={{ fontWeight: 'bold' }}>Urges to Binge or Overeat</h3>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">Sometimes I have strong urges to binge or overeat.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q5 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q5", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">Sometimes I really want to binge or overeat.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q6 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q6", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">Sometimes it's hard to resist the urge to overeat.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q7 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q7", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">Sometimes I struggle with the temptation to overeat</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q8 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q8", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>

                    <h3 className="font-md mb-4" style={{ fontWeight: 'bold' }}>Actual Binges</h3>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">I often binge and eat way too much, even when I'm not hungry</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q9 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q9", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold"> I often eat large amounts of food in a short period of time.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q10 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q10", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold"> I often eat alone because I feel embarrassed by how much I eat.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q11 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q11", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <h3 className="font-md mb-4" style={{ fontWeight: 'bold' }}>Loss of Control</h3>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">  I often eat much more rapidly than other people.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q12 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q12", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold"> I can't seem to control how much I eat. </div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q13 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q13", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold">Once I start, I can't seem to stop eating.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q14 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q14", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold"> I can't resist the urge to eat too much. </div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q15 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q15", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>

                    <h3 className="font-md mb-4" style={{ fontWeight: 'bold' }}>Emotional Consequences</h3>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold"> I often feel guilty ,ashamed and embarrassed when I eat too much. </div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q16 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q16", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold"> I often tend to overeat during parties and family gatherings.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q17 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q17", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold"> I often overeat during night while watching TV.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q18 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q18", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="assesment-cards mb-3">
                        <div className="dashboard-title mb-3">
                            <div className="font-smd fw-semibold"> I often tend to overeat when I am stressed, bored or lonely.</div>
                        </div>
                        <div className="d-flex flex-wrap gap-2">
                            {['not_at_all', 'slightly_true', 'moderately_true', 'very_true', 'completely_true'].map(option => (
                                <button
                                    key={option}
                                    className={`btn-prediabetes-table ${selectedAnswers.q19 === option ? "btn-selected" : ""} assessment_option_button`}
                                    onClick={() => handleSelection("q19", option)}
                                >
                                    {option.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                                </button>
                            ))}
                        </div>
                    </div>

                    <button className="btn_get_started btns btn-animation-blue mx-auto" onClick={calculateScore}>
                        Submit
                    </button>
                    {score !== null && (
                        <div className="d-flex justify-content-center align-items-center mt-4">
                            <div className="result-container w-12">
                                <div className="row">
                                    <div className="col-xl-4 mt-auto pb-3 mb-auto justify-content-center align-items-center">
                                        <div>
                                            <ProgressBar
                                                score={score}
                                                thresholds={[19, 38, 57]}
                                                labels={["Normal", "Mild", "Moderate", "Severe"]}
                                                colors={["#f44336", "#ff9800", "#4caf50", "#f44336"]}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-xl-8">
                                        <h2>Your Score: {score} / 76</h2>
                                        <div>
                                        {score <= 18 ? (
    <div className="mt-3">
      <p className="font-xsm">
      Your score in Binge eating assessment is {score} / 76. This indicates
no significant symptoms of binge eating. This score generally needs no immediate intervention and reflects healthy relationship with food  and
we recommend maintaining a balanced lifestyle and monitoring your habits along with these orientation counselling.
</p>
    </div>
  ) : score <= 37 ? (
    <div className="mt-3">
      <p className="font-xsm">
        Your score in Binge eating assessment is {score} / 76. This indicates occasional binge eating episodes, which may indicate a developing issue where eating is used to cope with stress or emotions.
 This score generally needs  increased self-awareness and early strategies to address triggers before the issue worsens and we recommend building healthier coping mechanisms, and considering brief counselling sessions along with these orientation counselling.
      </p>
    </div>
  ) : score <= 56 ? (
    <div className="mt-3">
      <p className="font-xsm">
        Your score in Binge eating assessment is {score} / 76. This indicates
frequent binge eating episodes that are likely associated with distress and challenges in managing eating behavior. This score generally needs professional intervention to address these patterns and their underlying causes and we recommend seeking therapy or counseling to develop healthier coping strategies and manage emotional triggers  along with these orientation counselling.
</p>
    </div>
  ) : (
    <div className="mt-3">
      <p className="font-xsm">
        Your score in Binge eating assessment is {score} / 76. This indicates a serious pattern of binge eating often linked to significant emotional distress and potential health risks. This score generally needs immediate professional intervention to address the issue effectively.
We recommend  seeking help from a psychologist, psychiatrist, or a specialized treatment program to manage these behaviors and address emotional and physical health concerns along with these orientation counselling.
</p>
    </div>
  )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    )
}

export default BingeEating